import SearchIcon from "@mui/icons-material/Search";
import { Grid, Stack } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import StatusCard from "../../../components/Dashboard/StatusCard";
import CustomRangePicker from "../../../components/DateRangePicker";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { CURRENCY } from "../../../constants/Variables";
import { getWorkerReport } from "../../../services/worker/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import ServiceAsAppointment from "./ServicesAppointment";
import ReportChart from "./ReportChart";
import ReportPiewChart from "./ReportPiewChart";
import AppLoader from "../../../components/AppLoader";
import { t } from "i18next";

function WorkerReports() {
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(1, "month"));
  const [endDate, setEndDate] = useState(moment());
  const [reportData, setReportData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData && startDate && endDate) {
      fetchWorkerReport(startDate, endDate);
    }
  }, [userData]);

  const fetchWorkerReport = async (startDate, endDate) => {
    let query = {
      startDate,
      endDate,
    };
    try {
      setIsLoading(true);
      const response = await getWorkerReport(userData?._id, query);
      if (response.data.status === "success") {
        const data = response.data.data;
        const finalChartData = data?.chartData?.map((val, ind) => {
          return {
            orders: val.totalAppointments,
            earnings: val.totalEarnings,
            date: new Date(val.date).getTime(),
          };
        });
        setReportData(data);
        setChartData(finalChartData);
        setAllServices(data.servicesStates);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cardData = [
    {
      primary: "totalAppointments",
      secondary: "totalAppointmentsScheduled",
      value: reportData?.totalAppointments || 0,
    },
    {
      primary: "completeAppointments",
      secondary: "totalAppointmentsCompleted",
      value: reportData?.completedAppointments || 0,
    },
    {
      primary: "earnings",
      secondary: "totalEarnings",
      value: `${CURRENCY} ${
        reportData?.totalEarnings[0]?.totalNetEarnings || 0
      }`,
    },
  ];

  const handleFilterData = () => {
    fetchWorkerReport(startDate, endDate);
  };

  console.log(allServices, "ALLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL");

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Stack direction={"row"} alignItems={"center"}>
          <CustomRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            stackProps={{
              borderRadius: "6px 0px 0px 6px",
              border: "1px solid #dddddd",
            }}
          />
          <GlobalButton
            endIcon={<SearchIcon />}
            handleClickBtn={handleFilterData}
            styleProps={{
              color: "primary",
              width: "auto",
              borderRadius: "0px 6px 6px 0px",
              minWidth: 45,
              height: "42px",
              "& .MuiButton-icon": {
                marginLeft: "0px",
              },
            }}
          />
        </Stack>
      </Stack>
    );
  };
  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("reportingAndAnalytics")}
        secondaryHeading={t("accessReports")}
        headProps={renderRightPart()}
      >
        <Grid container mt={3} spacing={1}>
          {cardData?.map((val, _ind) => {
            return <StatusCard item={val} index={_ind} />;
          })}
        </Grid>

        <ReportChart chartData={chartData} isLoading={isLoading} />

        <Grid container mt={3} spacing={1}>
          <Grid item xs={12} md={8}>
            <ServiceAsAppointment
              allServices={allServices}
              isLoading={isLoading}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ReportPiewChart allServices={allServices} isLoading={isLoading} />
          </Grid>
        </Grid>
      </AppContainer>
    </NavigationDrawer>
  );
}

export default WorkerReports;
